export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_LOADER_ON = "SET_LOADER_ON";
export const SET_LOADER_OFF = "SET_LOADER_OFF";

export const SET_LOGGED_IN = "SET_LOGGED_IN";
export const SET_VISA_FOR_EDIT = "SET_VISA_FOR_EDIT";
export const LOGIN_EMAIL_CONF_NEEDED = "LOGIN_EMAIL_CONF_NEEDED";
export const LOGOUT = "LOGOUT";
